import { createFileRoute } from '@tanstack/react-router';
import { LoginScreen } from '@/features/auth/components/LoginScreen';

export const Route = createFileRoute('/_auth/sign-in')({
  component: SignInPage,
});

function SignInPage() {
  const { auth } = Route.useRouteContext();
  return <LoginScreen onLogin={auth.login} error={auth.error} />;
}
